import { render, staticRenderFns } from "./OptionEditSubelementsTab.vue?vue&type=template&id=641289fe"
import script from "./OptionEditSubelementsTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditSubelementsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports